import React, { useContext, useEffect, useState } from 'react'

import { DateControlContext } from 'contexts/DateControlContext'
import LoaderScreen from 'uiKit/loaders/loaderScreen'

import { loadCarcoAdminDashboard } from '../../api/dashboard'
import { getDashboardDateApiParams } from '../../helpers/dashboardDateParams'
import * as S from '../CarecoAdminDashboard/CarecoAdminStyle'
import Overview from '../Overview'
import AdoptionSnapshot from '../AdoptionSnapshot'
import PendingActiion from '../PendingActiion'

/**
 * QCS dashboard.
 *
 * Same Careco dashboard load path (`GET /bot/{id}/dashboard`) and section
 * components as CareBrain Careco Admin. Layout stays QCS-trimmed: no Chats
 * card (`hideChats`) and no Top queried topics. Drill-downs use the same
 * `dashboardRoutes` as Careco (mounted in Dashboard.tsx).
 */
const QcsDashboard = ({ botId }) => {
  const {
    dateRange: { startDate, endDate },
    frequency,
  } = useContext(DateControlContext)
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!botId) return undefined

    let cancelled = false
    setLoading(true)
    const dateParams = getDashboardDateApiParams(frequency, startDate, endDate, true)
    loadCarcoAdminDashboard(botId, dateParams)
      .then(res => {
        if (!cancelled) setData(res || null)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [botId, startDate, endDate, frequency])

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
        <LoaderScreen />
      </div>
    )
  }

  return (
    <S.Section>
      <S.LeftColumn>
        <Overview data={data?.overview || null} showUserStatuses />
        <AdoptionSnapshot datas={data || null} hideChats />
        <S.FlexBlock style={{ gap: 16, alignItems: 'stretch' }}>
          <div style={{ flex: '1 1 100%', width: '100%', display: 'flex' }}>
            <PendingActiion data={data?.pendingActions || null} />
          </div>
        </S.FlexBlock>
      </S.LeftColumn>
    </S.Section>
  )
}

export default QcsDashboard
